import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import userManager from "user-manager";
import { loginSuccess } from "actions/authActions";
import AuthCallback from "components/Auth/Callback";

export const mapStateToProps = () => {
  return {
    userManager
  };
};

export const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      onSuccess: loginSuccess
    },
    dispatch
  );
};

const CallbackContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthCallback);

export default CallbackContainer;
